import { render, staticRenderFns } from "./ConfigurationTable.vue?vue&type=template&id=0325544b&scoped=true&"
import script from "./ConfigurationTable.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325544b",
  null
  
)

export default component.exports